module.exports = __webpack_public_path__ + "img/logo3.ef7ac3df.png";